module.exports = __webpack_public_path__ + "static/media/trash-dark58eccb99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/practice_admin/images/trash-dark.svg
// module id = 673
// module chunks = 0